import React from 'react';
import debounce from 'lodash/debounce';

import { showSuccess, showResponseError, showErrorWithSupportLink } from 'utils/messages';
import { trackingPageUrl, submitPostViaHiddenForm } from 'utils/wrappers';

import Brand from 'app/models/brand';

import Base from 'app/views/base';
import ColorPickerView from 'app/components/pages/brand/color_picker';
import ImageUploadPreviewView from 'app/components/pages/brand/image_preview';
import ImageUploadView from 'app/components/pages/brand/image_upload';
import ImageSelectorView from 'app/components/pages/brand/image_selector';
import PageHeader from 'app/components/page_header_react';

import tmpl from './template';

export const PREVIEW_TRACKING_PAGE_THROTTLE_WAIT = 500;

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'brand',

  events: {
    'submit #brand-form': 'submit',
    'click #preview-tracking-page': 'previewTrackingPage',
    'click #reset-brand': 'resetBrand',
    'keyup #ad_href,#logo_href,#name': 'setModelFromId',
  },

  initialize({ user }) {
    this.user = user;
    this.model = new Brand({ user: this.user });
    this.listenTo(this.model, 'sync', this.render);
    this.listenTo(this.model, 'change', debounce(() => {
      this.previewTrackingPage({ target: 'brand-theme-preview' });
    }, PREVIEW_TRACKING_PAGE_THROTTLE_WAIT, { trailing: true }));
    this.adImgMinWidth = 460;
    this.disableSubmit = false;

    this.addReactComponent('header', <PageHeader name="Brand" />);
    this.addSubview('themeSelector', '#theme_selector', new ImageSelectorView({ brand: this.model }));
    this.addSubview('logoImagePreview', '#logo_image_preview', new ImageUploadPreviewView({
      model: this.model, modelProperty: 'logo',
    }));
    this.addSubview('logoImageUpload', '#logo_image_upload', new ImageUploadView({
      model: this.model, modelProperty: 'logo',
    }));
    this.addSubview('colorPicker', '#color_picker', new ColorPickerView({
      model: this.model, modelProperty: 'color',
    }));
    this.addSubview('backgroundColorPicker', '#background_color_picker', new ColorPickerView({
      model: this.model,
      modelProperty: 'background_color',
      label: 'Background Color',
      placeholder: '(Theme Default)',
    }));
    this.addSubview('adImagePreview', '#ad_image_preview', new ImageUploadPreviewView({
      model: this.model, modelProperty: 'ad',
    }));
    this.addSubview('adImageUpload', '#ad_image_upload', new ImageUploadView({
      model: this.model,
      modelProperty: 'ad',
      removeText: 'Remove Ad',
      minWidth: this.adImgMinWidth,
    }));

    this.model.fetch();
  },

  context() {
    return {
      adHref: this.model.get('ad_href'),
      adImgMinWidth: this.adImgMinWidth,
      brandName: this.model.get('name'),
      logoHref: this.model.get('logo_href'),
      disableSubmit: this.disableSubmit,
    };
  },

  afterRender() {
    this.$('[data-toggle="tooltip"]').tooltip();
  },

  setModelFromId(e) {
    this.model.set(e.target.id, $(e.target).val());
  },

  previewTrackingPage({ target }) {
    submitPostViaHiddenForm({
      action: trackingPageUrl('test'),
      target,
      params: this.model.toJSON({ includeHrefs: true }),
    });
  },

  resetBrand(e) {
    e.preventDefault();
    this.model.setToDefaults({
      success() {
        showSuccess('Branding reset to defaults.');
      },
      error() {
        showErrorWithSupportLink('There was an error while resetting the branding.');
      },
    });
  },

  submit(e) {
    e.preventDefault();
    const self = this;
    self.disableSubmit = true;
    self.render();
    this.model.save({}, {
      success() {
        showSuccess('Brand Successfully Updated.');
      },
      error(model, response) {
        showResponseError(response);
      },
      wait: true,
    }).always(() => {
      self.disableSubmit = false;
      self.render();
    });
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/brand/index.jsx